import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SvgIconComponent } from '../../ui/svg-icon/svg-icon.component';
import { NgFor, NgIf } from '@angular/common';
import { Subject } from 'rxjs';
import { SnackbarData } from '../../models/snackbar';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [NgFor, NgIf, SvgIconComponent],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnDestroy {
  public messages: string[];
  duration: number | null;
  remainingSeconds: number | null;
  countdownInterval: any;

  destroy$ = new Subject<void>();

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: SnackbarData
  ) {
    this.messages = Array.isArray(data.messages) ? data.messages : [data.messages];
    this.duration = snackBarRef.containerInstance.snackBarConfig?.duration ?? null;

    // Only calculate remainingSeconds/countdown if duration is a finite number
    if (typeof this.duration === 'number' && isFinite(this.duration) && this.duration > 0) {
      this.remainingSeconds = Math.ceil(this.duration / 1000);
      this.countdownInterval = setInterval(() => {
        if (this.remainingSeconds !== null) {
          this.remainingSeconds--;
          if (this.remainingSeconds <= 0) {
            clearInterval(this.countdownInterval);
          }
        }
      }, 1000);
    } else {
      this.remainingSeconds = null;
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return 'check-circle';
      case 'error':
        return 'close-circle';
      case 'info':
        return 'info-cc';
      case 'warning':
        return 'warning-cc';
      default:
        return 'info-cc';
    }
  }

  close(): void {
    this.snackBarRef.dismiss();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
